module.exports = "/_next/static/images/find-employer-1e7b3e45fc1d2da10fb7d26a324f523c.png.webp";